import React, { useCallback, useContext, useState } from 'react';

import { Settings } from '@atlaskit/atlassian-navigation';
import { ButtonItem, MenuGroup } from '@atlaskit/menu';
import Popup from '@atlaskit/popup';
import { ThemeContext } from './theme-context';

const PopupContents = () => {
  const { theme, setTheme } = useContext(ThemeContext);
  const setLightTheme = useCallback(() => {
    setTheme?.({ colorMode: 'light' });
  }, [setTheme]);

  const setDarkTheme = useCallback(() => {
    setTheme?.({ colorMode: 'dark' });
  }, [setTheme]);
  return (
    <MenuGroup maxWidth={800} minWidth={320}>
      {theme.colorMode === 'light' && (
        <ButtonItem onClick={setDarkTheme}>{`Switch to dark theme`}</ButtonItem>
      )}
      {theme.colorMode === 'dark' && (
        <ButtonItem
          onClick={setLightTheme}
        >{`Switch to light Theme`}</ButtonItem>
      )}
    </MenuGroup>
  );
};

export const SettingsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);

  const closePopup = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <Popup
      isOpen={isOpen}
      onClose={closePopup}
      content={PopupContents}
      placement="bottom-end"
      trigger={(triggerProps) => {
        return (
          <Settings
            {...triggerProps}
            tooltip={'Settings'}
            onClick={handleClick}
          />
        );
      }}
    />
  );
};
